import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

import {
    getDummyText,
    renderStandardPictureElement,
    slideContent,
} from "../../../utils";

import {
    productSliderZoomSlide,
    heroSliderSlide,
    videoSliderSlide,
    contactCardSliderSlide,
    quoteSliderSlide,
    quoteSlider2Slide,
    productSliderSlide,
    tripleSliderSlide,
    notificationBigSliderSlide,
    galerieSliderSlide,
    galerieSliderSlideV2,
    productImageSliderSlide,
    heroSliderSlideMultipleButtons,
} from "./slides";

export default {
    title: "Website/Partial Templates/Slider",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const copyText1 = `„Welt im Wandel“ – das Motto unseres Geschäfts- berichts
                    2019/20. Mit bedachten Entscheidungen und loyalen Partnern
                    war es TRUMPF möglich, in diesen herausfordernden Zeiten ein
                    positives Geschäftsergebnis zu erzielen.`;

const copyText2 = `Beantworten Sie einfach ein paar Fragen zu Ihrer Anwendung
                          und wir zeigen Ihnen, welcher Laser am besten zu Ihnen passt!`;

const copyText3 = `Tauchen Sie ein in die Erfolgsgeschichten unserer Kunden und
                          lassen Sie sich inspirieren, wie auch Sie Ihre Fertigung durch
                          clevere Vernetzung, den Einstieg in additive Technologien oder
                          eine Investition in einen Laser fit für die Zukunft machen.`;

let i = 0;

function slide(dimensions, tag, title) {
    i++;
    return html`
        <div class="ux-block-hero">
            <div class="ux-block-hero__image">
                ${renderStandardPictureElement({
                    width: dimensions[0],
                    height: dimensions[1],
                    isInSlider: true,
                })}
            </div>
            <div class="ux-block-hero__content">
                <span class="ux-text-small ux-text-small--bold"> ${tag} </span>
                <h2 class="ux-text-headline ux-text-headline--big">${title}</h2>
                <div>
                    <p class="ux-text-normal ux-text-normal--light-gray">
                        ${i === 1 ? copyText1 : i === 2 ? copyText2 : copyText3}
                    </p>
                </div>
                <div class="ux-block-hero__button-block">
                    <a class="ux-button" href="#">Mehr erfahren</a>
                </div>
            </div>
        </div>
    `;
}

export const HomepageSlider = () => {
    return html`
        <ux-slider
            autoplay
            pause-on-hover="ux-block-hero__content"
            loop
            lazy-load
            arrows-follow-img
            no-drag
        >
            <ux-slider-slide>
                ${slide(
                    [1890, 630],
                    "SMART FACTORY",
                    "Geschäftsbericht 2019/20"
                )}
            </ux-slider-slide>
            <ux-slider-slide>
                ${slide(
                    [1920, 640],
                    "LASER MACHINE",
                    "Finden Sie Ihren perfekten TruMark Beschriftungslaser!"
                )}
            </ux-slider-slide>
            <ux-slider-slide>
                ${slide(
                    [1950, 650],
                    "JOBS",
                    "Viele Erfolgsgeschichten – ein Partner"
                )}
            </ux-slider-slide>
            <ux-slider-pagination bottom-pagination slot="pagination">
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const productSliderZoom = () => {
    return html`
        <ux-slider
            loop
            autoplay
            pause-on-hover
            arrows-follow-img
            no-arrows
            effect="fade"
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-iws-slider-slide-zoomable>
                ${productSliderZoomSlide(
                    getDummyText(60),
                    "product-1.png",
                    "TruBend 1000 Basic Edition"
                )}
            </ux-iws-slider-slide-zoomable>
            <ux-iws-slider-slide-zoomable>
                ${productSliderZoomSlide(
                    getDummyText(80),
                    "product-2.png",
                    "TruLaser 1030"
                )}
            </ux-iws-slider-slide-zoomable>
            <ux-slider-pagination slot="pagination" anchor-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};

const dummyTextsDoubleTeaserSlider = [
    getDummyText(230),
    getDummyText(310),
    getDummyText(250),
    getDummyText(390),
    getDummyText(290),
];

export const doubleTeaserSlider = () => {
    return html`
        <ux-slider
            class="gr-12 no-gutter"
            visible-slides-xl="2"
            visible-slides-l="2"
            breakpoint-l="1024"
            breakpoint-s="567"
            space-between-xl="10"
            space-between-l="10"
            container-classes="gr-10 push-1 gr-12@m push-0@m no-gutter"
            slides-auto-height
        >
            ${dummyTextsDoubleTeaserSlider.map((index) => {
                return html`
                    <ux-slider-slide class="u-paddingBottom-md u-paddingTop-md">
                        <ux-iws-teaser-image
                            text-wrapper-column
                            class="ux-u-background-white ux-u-margin-horizontal-20"
                        >
                            <div slot="image">
                                ${renderStandardPictureElement({
                                    width: 538,
                                    height: 471,
                                })}
                            </div>
                            <div
                                class="ux-text-title-teaser ux-u-margin-bottom-10"
                            >
                                ${html`
                                    ${index !== "1"
                                        ? `The title of the
                                        teaser`
                                        : `Longer title of the teaser that spans multiple lines`}
                                `}
                            </div>
                            <div
                                slot="text"
                                class="text-normal u-color-gray-paragraph ux-u-margin-children-0"
                            >
                                <p>Some text</p>
                            </div>
                            <div
                                slot="cta"
                                class="ux-u-margin-top-30 ux-u-center-content"
                            >
                                <a href="#" class="btn">Mehr erfahren</a>
                            </div>
                        </ux-iws-teaser-image>
                    </ux-slider-slide>
                `;
            })}
            <ux-slider-pagination
                slot="pagination"
                class="no-gutter"
                bottom-pagination
            ></ux-slider-pagination>
        </ux-slider>
    `;
};

export const videoSlider = () => {
    return html`
        <ux-slider
            loop
            container-classes="gr-10 push-1 gr-12@t push-0@t gr-12@m push-0@m"
            no-arrows
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide> ${videoSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${videoSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${videoSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${videoSliderSlide} </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
videoSlider.storyName = "Video Slider (B.3)";

export const heroSlider = () => {
    return html`
        <ux-slider effect="fade" arrows-follow-img loop>
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide> ${heroSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${heroSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${heroSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${heroSliderSlide} </ux-slider-slide>
            <ux-slider-pagination slot="pagination" anchor-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
heroSlider.storyName = "Hero Slider (D.5)";

export const heroSliderMultipleButtons = () => {
    return html`
        <ux-slider effect="fade" arrows-follow-img loop>
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide>
                ${heroSliderSlideMultipleButtons}
            </ux-slider-slide>
            <ux-slider-slide>
                ${heroSliderSlideMultipleButtons}
            </ux-slider-slide>
            <ux-slider-slide>
                ${heroSliderSlideMultipleButtons}
            </ux-slider-slide>
            <ux-slider-slide>
                ${heroSliderSlideMultipleButtons}
            </ux-slider-slide>
            <ux-slider-pagination
                slot="pagination"
                anchor-pagination
            ></ux-slider-pagination>
        </ux-slider>
    `;
};
heroSliderMultipleButtons.storyName = "Hero Slider (D.5) Multiple Buttons";

export const contactSlider = () => {
    return html`
        <ux-slider
            loop
            visible-slides-xl="1"
            visible-slides-l="1"
            visible-slides-m="1"
        >
            <ux-slider-slide class="contact-card slider-slide u-clearfix">
                ${contactCardSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="contact-card slider-slide u-clearfix">
                ${contactCardSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="contact-card slider-slide u-clearfix">
                ${contactCardSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="contact-card slider-slide u-clearfix">
                ${contactCardSliderSlide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const quoteListSlider = () => {
    return html`
        <ux-slider
            loop
            container-classes="gr-10 push-1 gr-12@t push-0@t gr-12@m push-0@m"
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide class="quote-list-single noImg u-clearfix">
                ${quoteSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single noImg u-clearfix">
                ${quoteSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single noImg u-clearfix">
                ${quoteSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single noImg u-clearfix">
                ${quoteSliderSlide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
quoteListSlider.storyName = "Quote List Slider (B.7)";

export const quoteListImageSlider = () => {
    return html`
        <ux-slider loop container-classes="gr-10 push-1 gr-12@m push-0@m">
            <!-- LOOP THROUGH THE SLIDES -->
            <ux-slider-slide class="quote-list-single u-clearfix">
                ${quoteSlider2Slide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single u-clearfix">
                ${quoteSlider2Slide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single u-clearfix">
                ${quoteSlider2Slide}
            </ux-slider-slide>
            <ux-slider-slide class="quote-list-single u-clearfix">
                ${quoteSlider2Slide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
quoteListImageSlider.storyName = "Quote List Image Slider (B.7)";

export const productSlider = () => {
    return html`
        <ux-slider
            loop
            arrows-follow-img
            visible-slides-xl="auto"
            visible-slides-l="auto"
            visible-slides-m="2"
            breakpoint-l="1024"
            breakpoint-m="768"
            breakpoint-s="567"
            container-classes="gr-10 push-1 gr-12@m push-0@m"
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide
                class="block block-product-slider-entry slider-slide"
            >
                ${productSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide
                class="block block-product-slider-entry slider-slide"
            >
                ${productSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide
                class="block block-product-slider-entry slider-slide"
            >
                ${productSliderSlide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const tripleSlider = () => {
    return html`
        <ux-slider
            loop
            visible-slides-xl="3"
            visible-slides-l="2"
            visible-slides-m="2"
            breakpoint-l="1024"
            breakpoint-m="768"
            breakpoint-s="567"
            container-classes="gr-10 push-1 gr-12@m push-0@m ux-u-margin-vertical-10"
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide class="block-product-slider-entry">
                ${tripleSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="block-product-slider-entry">
                ${tripleSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="block-product-slider-entry">
                ${tripleSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="block-product-slider-entry">
                ${tripleSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="block-product-slider-entry">
                ${tripleSliderSlide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
tripleSlider.storyName = "Triple Slider (C.12)";

export const productImageSlider = () => {
    return html`
        <ux-slider loop arrows-follow-img>
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide> ${productImageSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${productImageSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${productImageSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${productImageSliderSlide} </ux-slider-slide>
            <div class="block-shadow"></div>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const productVideoSlider = (twoSlides = true) => {
    return html`
        <div class="row">
            <div
                class="gr-10 push-1 gr-12@m push-0@m no-gutter u-marginBottom-60 u-marginTop-50"
            >
                <ux-slider loop no-arrows>
                <!-- LOOP THROUGH THE SLIDES HERE -->
                <ux-slider-slide>
                    <div class="row embed-video">
                        <div class="gr-12 u-textCenter"></div>
                        <div class="gr-12 u-marginBottom-15">
                            <ux-video>
                                <video controls="" id="video_1t1dq9q8iwp">
                                    <source
                                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                                        type="video/mp4"
                                    />
                                </video>
                            </ux-video>
                        </div>
                        <div
                            class="gr-12 u-textLeft caption"
                        >
                            <div class="text-normal">
                                Lorem ipsum dolor sit amet,
                                consectetur
                            </div>
                        </div>
                    </div>
                </ux-slider-slide>
                ${
                    twoSlides
                        ? html`
                              <ux-slider-slide>
                                  <div class="row">
                                      <div class="gr-12 u-textCenter"></div>
                                      <div class="gr-12 u-marginBottom-15">
                                          <ux-video>
                                              <video
                                                  controls=""
                                                  id="video_1t1dq9q8iwp"
                                              >
                                                  <source
                                                      src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                                                      type="video/mp4"
                                                  />
                                              </video>
                                          </ux-video>
                                      </div>
                                  </div>
                              </ux-slider-slide>
                          `
                        : ``
                }
                    <div class="block-shadow"></div>
                    <ux-slider-pagination slot="pagination" bottom-pagination>
                    </ux-slider-pagination>
                <ux-slider>
            </div>
        </div>
    `;
};

export const notificationSlider = () => {
    return html`
        <ux-slider
            loop
            arrows-follow-img
            container-classes="gr-10 push-1 gr-12@m push-0@m no-gutter@m"
        >
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide class="notification-slider-entry">
                ${notificationBigSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="notification-slider-entry">
                ${notificationBigSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="notification-slider-entry">
                ${notificationBigSliderSlide}
            </ux-slider-slide>
            <ux-slider-slide class="notification-slider-entry">
                ${notificationBigSliderSlide}
            </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const galerieSlider = () => {
    return html`
        <ux-slider loop arrows-follow-img>
            <!-- LOOP THROUGH THE SLIDES HERE -->
            <ux-slider-slide> ${galerieSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${galerieSliderSlideV2} </ux-slider-slide>
            <ux-slider-slide> ${galerieSliderSlide} </ux-slider-slide>
            <ux-slider-slide> ${galerieSliderSlideV2} </ux-slider-slide>
            <ux-slider-pagination slot="pagination" bottom-pagination>
            </ux-slider-pagination>
        </ux-slider>
    `;
};
galerieSlider.storyName = "Galerie Slider (B.2)";

export const successStoriesSlider = () => {
    return html`
        <ux-slider
            loop
            effect="fade"
            auto-height
            arrows-follow-img=".ux-iws-teaser-success-story__wrapper-background"
        >
            <ux-slider-slide>
                <div class="ux-iws-teaser-success-story__wrapper">
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background ux-slider-lazy-img-waiting"
                        data-background="[object Object]"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background-cutter"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-teaser-container"
                    >
                        <a
                            href="#"
                            class="ux-button ux-iws-teaser-success-story__wrapper-cta"
                            >Alle berichte</a
                        >
                        <div class="ux-iws-teaser-success-story">
                            <div
                                class="ux-iws-teaser-success-story__img-container"
                            >
                                <picture>
                                    <source
                                        media="(max-width: 567px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        media="(max-width: 1024px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <img
                                        class=" ls-is-cached lazyloaded"
                                        alt="17:8 standard - viewport test images /w Retina support"
                                        src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        data-src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                </picture>
                            </div>
                            <div class="ux-iws-teaser-success-story__content">
                                <ux-icon
                                    class="ux-iws-teaser-success-story__icon"
                                    name="quotation-mark"
                                >
                                </ux-icon>
                                <div
                                    class="ux-iws-teaser-success-story__text-content"
                                >
                                    <ux-text-lines-limit text-lines="2">
                                        <h2
                                            class="ux-text-headline ux-text-headline--medium"
                                        >
                                            Consectetur Adipiscing Ipsum
                                            Adipiscing Ipsum Adipiscing Ipsum
                                        </h2>
                                    </ux-text-lines-limit>
                                    <span
                                        class="ux-u-text-bold ux-u-margin-l-bottom-5"
                                        >Lorem ipsum dolor sit amet consectur
                                        dolor lorem ipsum dolor sit amet</span
                                    >
                                    <div
                                        class="ux-iws-teaser-success-story__body"
                                    >
                                        <ux-text-lines-limit
                                            text-lines-s="3"
                                            text-lines-m="3"
                                            text-lines-l="2"
                                            text-lines-xl="2"
                                            class="ux-iws-teaser-success-story__copy-limiter"
                                        >
                                            <p
                                                class="ux-text-normal ux-text-normal--light-gray"
                                            >
                                                Lorem ipsum dolor sit amet,
                                                consetetur sadipscing elitr, sed
                                                diam nonumy eirmod tempor
                                                invidunt ut labore et dolore
                                                magna aliquyam erat, sed.
                                            </p>
                                        </ux-text-lines-limit>
                                    </div>
                                </div>
                                <a class="ux-button ux-button--green" href="#">
                                    Geschichten lesen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ux-slider-slide>
            <ux-slider-slide>
                <div class="ux-iws-teaser-success-story__wrapper">
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background ux-slider-lazy-img-waiting"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background-cutter"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-teaser-container"
                    >
                        <a
                            href="#"
                            class="ux-button ux-iws-teaser-success-story__wrapper-cta"
                            >Alle berichte</a
                        >
                        <div class="ux-iws-teaser-success-story">
                            <div
                                class="ux-iws-teaser-success-story__img-container"
                            >
                                <picture>
                                    <source
                                        media="(max-width: 567px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        media="(max-width: 1024px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <img
                                        class="ls-is-cached lazyloaded"
                                        alt="17:8 standard - viewport test images /w Retina support"
                                        src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        data-src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                </picture>
                            </div>
                            <div class="ux-iws-teaser-success-story__content">
                                <ux-icon
                                    class="ux-iws-teaser-success-story__icon"
                                    name="quotation-mark"
                                >
                                </ux-icon>
                                <div
                                    class="ux-iws-teaser-success-story__text-content"
                                >
                                    <ux-text-lines-limit text-lines="2">
                                        <h2
                                            class="ux-text-headline ux-text-headline--medium"
                                            style="max-height: 100%;"
                                        >
                                            Consectetur Adipiscing Ipsum
                                        </h2>
                                    </ux-text-lines-limit>
                                    <span
                                        class="ux-u-text-bold ux-u-margin-l-bottom-5"
                                        >Lorem ipsum dolor sit amet consectur
                                        dolor lorem ipsum dolor sit amet</span
                                    >
                                    <div
                                        class="ux-iws-teaser-success-story__body"
                                    >
                                        <ux-text-lines-limit
                                            text-lines-s="3"
                                            text-lines-m="3"
                                            text-lines-l="2"
                                            text-lines-xl="2"
                                            class="ux-iws-teaser-success-story__copy-limiter"
                                        >
                                            <p
                                                class="ux-text-normal ux-text-normal--light-gray"
                                                style="max-height: 67px;"
                                            >
                                                Lorem ipsum dolor sit amet,
                                                consetetur sadipscing elitr, sed
                                                diam nonumy eirmod tempor
                                                invidunt ut labore et dolore
                                                magna aliquyam erat, sed.
                                            </p>
                                        </ux-text-lines-limit>
                                    </div>
                                </div>
                                <a class="ux-button ux-button--green" href="#">
                                    Geschichten lesen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ux-slider-slide>
            <ux-slider-slide>
                <div class="ux-iws-teaser-success-story__wrapper">
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background ux-slider-lazy-img-waiting"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-background-cutter"
                    ></div>
                    <div
                        class="ux-iws-teaser-success-story__wrapper-teaser-container"
                    >
                        <a
                            href="#"
                            class="ux-button ux-iws-teaser-success-story__wrapper-cta"
                            >Alle berichte</a
                        >
                        <div class="ux-iws-teaser-success-story">
                            <div
                                class="ux-iws-teaser-success-story__img-container"
                            >
                                <picture>
                                    <source
                                        media="(max-width: 567px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        media="(max-width: 1024px)"
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <source
                                        data-srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        srcset="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                    <img
                                        class=" ls-is-cached lazyloaded"
                                        alt="17:8 standard - viewport test images /w Retina support"
                                        src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                        data-src="data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 400 400%22 style%3D%22background%3A %23e7e7e7%22%3E %3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%22-22.4 -37.5 135 165%22%3E %3Cpath fill%3D%22%23a1a1a1%22 d%3D%22M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z%22%2F%3E %3C%2Fsvg%3E %3C%2Fsvg%3E"
                                    />
                                </picture>
                            </div>
                            <div class="ux-iws-teaser-success-story__content">
                                <ux-icon
                                    class="ux-iws-teaser-success-story__icon"
                                    name="quotation-mark"
                                >
                                </ux-icon>
                                <div
                                    class="ux-iws-teaser-success-story__text-content"
                                >
                                    <ux-text-lines-limit text-lines="2">
                                        <h2
                                            class="ux-text-headline ux-text-headline--medium"
                                            style="max-height: 100%;"
                                        >
                                            Consectetur Adipiscing Ipsum
                                        </h2>
                                    </ux-text-lines-limit>
                                    <span
                                        class="ux-u-text-bold ux-u-margin-l-bottom-5"
                                        >Lorem ipsum dolor sit amet consectur
                                        dolor lorem ipsum dolor sit amet</span
                                    >
                                    <div
                                        class="ux-iws-teaser-success-story__body"
                                    >
                                        <ux-text-lines-limit
                                            text-lines-s="3"
                                            text-lines-m="3"
                                            text-lines-l="2"
                                            text-lines-xl="2"
                                            class="ux-iws-teaser-success-story__copy-limiter"
                                        >
                                            <p
                                                class="ux-text-normal ux-text-normal--light-gray"
                                                style="max-height: 67px;"
                                            >
                                                Lorem ipsum dolor sit amet,
                                                consetetur sadipscing elitr, sed
                                                diam nonumy eirmod tempor
                                                invidunt ut labore et dolore
                                                magna aliquyam erat, sed.
                                            </p>
                                        </ux-text-lines-limit>
                                    </div>
                                </div>
                                <a class="ux-button ux-button--green" href="#">
                                    Geschichten lesen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ux-slider-slide>
            <ux-slider-pagination
                anchor-pagination
                slot="pagination"
            ></ux-slider-pagination>
        </ux-slider>
    `;
};
successStoriesSlider.storyName = "Success Stories Slider (H.4)";

export const relatedTopicsSlider = () => {
    return html`
        <ux-slider
            no-arrows
            visible-slides-xl="3"
            visible-slides-l="2"
            visible-slides-m="1"
            visible-slides-s="1"
            breakpoint-s="767"
            breakpoint-m="1023"
            breakpoint-l="1439"
            space-between-xl="30"
            space-between-l="30"
            space-between-m="30"
            space-between-s="10"
            container-classes="no-gutter gr-10 push-1 gr-8@tMin768 push-2@tMin768 gr-10@d push-1@d gr-10@large push-1@large ux-u-margin-vertical-25"
            faded-sides
            slides-overflow-visible
            slides-auto-height
        >
            <ux-slider-slide>
                <ux-iws-teaser-image inline-text-slot image-auto-height>
                    <div slot="image">
                        ${renderStandardPictureElement({
                            width: 400,
                            height: 400,
                        })}
                    </div>
                    <div
                        slot="text"
                        class="ux-text-normal ux-text-normal--light-gray ux-u-margin-children-0"
                    >
                        <strong class="ux-label">
                            Lorem ipsum dolor sit amet
                        </strong>
                        <span class="ux-u-text-bold u-color-black"
                            >Webspecial Highspeed</span
                        >
                        <p>${getDummyText(110)}</p>
                        <p>${getDummyText(120)}</p>
                    </div>
                    <div slot="cta">
                        <a
                            class="ux-button ux-button--icon-only"
                            href="#"
                            aria-label="Lorem Ipsum"
                            role="button"
                        >
                            <ux-icon
                                name="chevron-right"
                                weight="normal"
                            ></ux-icon>
                        </a>
                    </div>
                </ux-iws-teaser-image>
            </ux-slider-slide>
            <ux-slider-slide>
                <ux-iws-teaser-image inline-text-slot image-auto-height>
                    <div slot="image">
                        ${renderStandardPictureElement({
                            width: 400,
                            height: 300,
                        })}
                    </div>
                    <div
                        slot="text"
                        class="ux-text-normal ux-text-normal--light-gray ux-u-margin-children-0"
                    >
                        <span class="ux-u-text-bold u-color-black"
                            >Webspecial TruLaser Center 7030</span
                        >
                        <p>${getDummyText(210)}</p>
                    </div>
                    <div slot="cta">
                        <a
                            class="ux-button ux-button--icon-only"
                            href="#"
                            aria-label="Lorem Ipsum"
                            role="button"
                        >
                            <ux-icon
                                name="chevron-right"
                                weight="normal"
                            ></ux-icon>
                        </a>
                    </div>
                </ux-iws-teaser-image>
            </ux-slider-slide>
            <ux-slider-slide>
                <ux-iws-teaser-image inline-text-slot image-auto-height>
                    <div slot="image">
                        ${renderStandardPictureElement({
                            width: 400,
                            height: 300,
                        })}
                    </div>
                    <div
                        slot="text"
                        class="ux-text-normal ux-text-normal--light-gray ux-u-margin-children-0"
                    >
                        <span class="ux-u-text-bold u-color-black"
                            >Autonomous laser cutting. Look deeper. Think
                            ahead</span
                        >
                        <p>${getDummyText(240)}</p>
                    </div>
                    <div slot="cta">
                        <a
                            class="ux-button ux-button--icon-only"
                            href="#"
                            aria-label="Lorem Ipsum"
                            role="button"
                        >
                            <ux-icon
                                name="chevron-right"
                                weight="normal"
                            ></ux-icon>
                        </a>
                    </div>
                </ux-iws-teaser-image>
            </ux-slider-slide>
            <ux-slider-pagination
                class="no-gutter"
                slot="pagination"
                bottom-pagination
            >
            </ux-slider-pagination>
        </ux-slider>
    `;
};

export const SectionsSlider = (withHeadline = false) => {
    return html`
        <div>
            ${withHeadline
                ? html`
                      <h2
                          class="ux-text-headline ux-text-headline--big ux-u-text-align--center
                            ux-u-margin-bottom-25 ux-u-margin-xl-bottom-35 ux-u-margin-top-0"
                      >
                          Lorem ipsum dolor sit amet
                      </h2>
                  `
                : html``}
            <ux-slider
                effect="slide"
                no-arrows
                breakpoint-s="767"
                breakpoint-m="1023"
                breakpoint-l="1439"
                container-width-s="315px"
                container-width-m="83.33%"
                container-width-l="83.33%"
                container-width-xl="83.33%"
                visible-slides-xl="4"
                visible-slides-l="3"
                visible-slides-m="2"
                visible-slides-s="1"
                space-between-xl="30"
                space-between-l="30"
                space-between-m="30"
                space-between-s="10"
                faded-sides
            >
                <ux-slider-slide> ${slideContent("Karriere")} </ux-slider-slide>
                <ux-slider-slide>
                    ${slideContent("Das Unternehmen")}
                </ux-slider-slide>
                <ux-slider-slide> ${slideContent("Presse")} </ux-slider-slide>
                <ux-slider-slide>
                    ${slideContent("Social Media Wall")}
                </ux-slider-slide>
                <ux-slider-pagination
                    class="ux-u-margin-top-10 ux-u-margin-l-top-15"
                    slot="pagination"
                    bottom-pagination
                >
                </ux-slider-pagination>
            </ux-slider>
        </div>
    `;
};
SectionsSlider.storyName = "Sections Slider (H.18)";
